export const getRegime = (regimes, regimeId) => {
    const regime = regimes.find((item) => item.regime_id === regimeId);
    if (regime) {
        return regime;
    }
    return false;
};

export default getRegime;
